import React, { useState } from 'react';

const PLATFORMS = [
  { value: 'windows-x86_64', label: 'Windows' },
  { value: 'linux-x86_64', label: 'Linux' },
];

export default function AgentDownloadControl({ COLORS, downloadInfo }) {
  const [platform, setPlatform] = useState('windows-x86_64');
  const downloads = Array.isArray(downloadInfo?.downloads) && downloadInfo.downloads.length
    ? downloadInfo.downloads
    : [{ ...downloadInfo, platform: 'windows-x86_64' }];
  if (!downloads.some((item) => item.available && item.download_url)) return null;
  const selected = downloads.find((item) => item.platform === platform);
  const available = !!selected?.available && !!selected?.download_url;
  const style = {
    display: 'inline-flex', alignItems: 'center', padding: '8px 12px', borderRadius: '999px',
    border: `1px solid ${COLORS.border}`, background: COLORS.card, color: COLORS.text,
    fontSize: '12px', fontWeight: '700', textDecoration: 'none',
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
      <select
        aria-label="Betriebssystem für Agent-Download"
        value={platform}
        onChange={(event) => setPlatform(event.target.value)}
        style={{ ...style, cursor: 'pointer' }}
      >
        {PLATFORMS.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
      </select>
      {available ? (
        <a href={selected.download_url} download={selected.file_name || undefined} style={style}>
          Agent herunterladen{selected.version ? ` v${selected.version}` : ''}
        </a>
      ) : (
        <span role="status" style={{ color: COLORS.muted, fontSize: '12px' }}>Für {PLATFORMS.find((item) => item.value === platform)?.label} noch nicht verfügbar</span>
      )}
    </div>
  );
}
